export default "__VITE_ASSET__DlOjcQsX__"